import { render, staticRenderFns } from "./EntregaEquipo.vue?vue&type=template&id=2dfb0e33&"
import script from "./EntregaEquipo.vue?vue&type=script&lang=js&"
export * from "./EntregaEquipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports